import { createMinerApp } from '@/lib/createMinerApp'

createMinerApp({ namespace: 'Bizminer' })
